import React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

type Props = React.SVGProps<SVGSVGElement>

const Close = (props: Props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    className={classnames(styles.icon, props.className)}
  >
    <path d="M17.5 6.5L6.5 17.5M17.5 17.5L6.5 6.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
  </svg>
);

export default React.memo(Close);
